import { LayerRenderer } from '../LayerRenderer';
import { CloseButton, cardStyle, useDismissible, type SurfaceProps } from './common';

/**
 * Vrstva v toku stránky (`banner`, `inline`, `recommendation`). Vykresluje ji
 * `<LayerSlot>` do pojmenovaného místa; nepřerušuje, nemá overlay ani
 * scroll-lock. Zavření je volitelné (banner/recommendation ho většinou nemá).
 */
export function InlineSurface({ layer, onClose, onInteract, onSubmitted }: SurfaceProps) {
  const settings = layer.doc.settings;
  useDismissible(onClose);
  const closable = settings.closeButton === true;

  return (
    <div className={`layer-inline layer-inline-${layer.kind}`} style={cardStyle(settings, false)}>
      {closable && <CloseButton onClose={onClose} />}
      <LayerRenderer
        layer={layer}
        onClose={onClose}
        onInteract={onInteract}
        onSubmitted={onSubmitted}
      />
    </div>
  );
}
